import { tvpil } from '../compat/tvpil';

export function useProviderLogo(providerName?: string) {
  return tvpil.providersRepository.providerGridLogo(providerName);
}
